export default __webpack_public_path__ + "static/15_34-0e18147f6d82fc713c74e88c6301432c.png";